import React from 'react';

const NewMexico = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        New Mexico Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          Standard disclosure of known defects required; no specific form
          mandated.
        </li>
      </ol>
    </div>
  );
};

export default NewMexico;
